export default __webpack_public_path__ + "static/media/site_aidasenegal.ce7d8e43.webp";